var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui green message"},[_c('div',{staticClass:"header"},[_vm._v("請輸入關鍵字查詢列車時刻")]),_vm._v(" "),_c('p',[_vm._v("輸入起迄站、時間、車種即可。「中壢 新竹」「鳳山 新左營 11/7」「台北 花蓮 太魯閣」「嘉義 民雄 星期四 莒光」")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7302281e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timetable/SearchTips.vue
// module id = Bjt9
// module chunks = 1